import { render, staticRenderFns } from "./IssueFastFerryMasterCertificate.vue?vue&type=template&id=54c587d1&scoped=true"
import script from "./IssueFastFerryMasterCertificate.vue?vue&type=script&lang=ts"
export * from "./IssueFastFerryMasterCertificate.vue?vue&type=script&lang=ts"
import style0 from "./IssueFastFerryMasterCertificate.vue?vue&type=style&index=0&id=54c587d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c587d1",
  null
  
)

export default component.exports